import { useState, useContext, useEffect, useRef } from "react"
import { BtnLoader, CSelect, toast, CInputText, CInputPassword, CToggle, CModal, CInputTextArea } from "../../../components/widget"
import { ContextNav, ContextDashboard, ContextLoading } from "../../../context";
import { AddJobsGroupApi } from "../../../api";
import { useNavigate, Link } from "react-router-dom";

export const JobGroupsAdd = () => {
    const navigate = useNavigate()
    const formRef: any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)


    const onFinishAdd = async (e: any) => {
        e.preventDefault()
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await AddJobsGroupApi(formRef)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast(res.message, { type: "success" })
            navigate('/p/settings/job-groups');
        }
        else {
            toast(res.message, { type: "error" })
        }
    }



    useEffect(() => {
        document.title = "ایجاد گروه شغلی | دایان"
        CtxNav.setActiveMenuItem({ 'item': 3, 'subItem': 0, })
    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">اضافه کردن گروه‌شغلی</h1>

            <form ref={formRef} onSubmit={onFinishAdd} className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:py-[30px] sm:px-[20px] px-[10px]">


                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-full h-full pl-1">
                                <CInputText name="name" title="عنوان گروه شغلی" type="text" required={true} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-fit flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-full h-full pl-1">
                                <CInputTextArea name="description" title="توضیحات" custom_class="min-h-[100px]"  />
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-[50%] h-full pl-1 flex items-center">
                                <span className="text-sm mx-2">فعال</span>
                                <div className="flex flex-col justify-center items-center">
                                    <span className="text-[10px]  mb-2 text-center ">وضعیت گروه شغلی</span>
                                    <CToggle name="status" defaultChecked={true} />
                                </div>
                                <span className="text-sm mx-2">غیر فعال</span>
                            </div>
                        </div>
                    </div>
                </div>


                <div className=" w-full mt-[40px] flex items-center">
                    {CtxLoad.displayLoadingBtn ?
                        <button type="button" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow cursor-not-allowed relative flex justify-center items-center"><BtnLoader /></button>
                        :
                        <button type="submit" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow">اعمال</button>
                    }
                    <Link to='/p/settings/job-groups'>
                        <button type="button" className="w-[100px] h-[40px] bg-[#a4a4a4] text-dayan-gray-200 rounded-[5px] mr-3 text-sm shadow">بازگشت</button>
                    </Link>
                </div>

            </form>



        </div>
    )
}
